import React from 'react';
import ChecklistItem from './ChecklistItem';
import InputItem from './InputItem';
import SelectItem from './SelectItem';
import SubmissionDetailCard from './SubmissionDetailCard';
import { CriteriaTypeDetailTypeEnumValue } from 'enums/CriteriaTypeDetailTypeEnum';

// Renders the correct detail component based on type
const RenderItem = ({ detail, allDetails = [], isReadOnly = false }) => {
  if (detail.criteriaTypeDetailType === CriteriaTypeDetailTypeEnumValue.Photo) {
    return <SubmissionDetailCard key={detail.id} detail={detail} allDetails={allDetails} isReadOnly={isReadOnly} />;
  }
  if (detail.criteriaTypeDetailType === CriteriaTypeDetailTypeEnumValue.Checkbox) {
    return <ChecklistItem key={detail.id} detail={detail} allDetails={allDetails} level={1} isReadOnly={isReadOnly} />;
  }
  if (detail.criteriaTypeDetailType === CriteriaTypeDetailTypeEnumValue.Input) {
    return <InputItem key={detail.id} detail={detail} allDetails={allDetails} level={1} isReadOnly={isReadOnly} />;
  }
  if (detail.criteriaTypeDetailType === CriteriaTypeDetailTypeEnumValue.Dropdown) {
    return <SelectItem key={detail.id} detail={detail} allDetails={allDetails} level={1} isReadOnly={isReadOnly} />;
  }
  return null;
};

export default RenderItem;
